//@flow
export default {
  admin: {
    title: "Admin",
    nav: {
      home: "Home",
      kiosks: "Kiosks",
      sensors: "Sensors",
      loops: "Loops",
      users: "Users",
      logout: "Logout"
    },
    dashboard: {
      title: "Dashboard",
      kiosks: {
        newButtonText: "New Kiosk",
        viewAll: "View All Kiosks",
        title: "Kiosks",
        description:
          "Kiosk users represent an actual kiosk installation that has access to the kiosk UI but not this admin tool."
      },
      attractLoops: {
        newButtonText: "New Attract Loop",
        viewAll: "View All Loops",
        title: "Attract Loops",
        description:
          "Attract Loops are presented on an individual kiosk as it's initial view and / or screen saver while a kiosk has been idle."
      },
      users: {
        newButtonText: "New User",
        viewAll: "View All Users",
        title: "Users",
        description:
          "Users are administrators for the kiosk system you're logged into at this very moment. Unlike Kiosk users, admin users do not access the kiosk UI itself but only this admin portal to manage the system."
      },
      sensors: {
        newButtonText: "New Sensor",
        viewAll: "View All Sensors",
        title: "Sensors",
        description:
          "Sensors represent the air quality equipment and the data they provide from various kiosks. Sensors can be matched to a kiosk to ensure they're interactive visualizations provide the right data."
      }
    }
  },
  kiosk: {
    language: {
      alternate: "Español",
      title: "¿Cambiar al español?",
      subtitle: "Siempre puedes volver al inglés.",
      confirm: "Si",
      cancel: "No"
    },
    confirmation: {
      title: {
        email: "Thanks!",
        phone: "Thanks!"
      },
      subtitle: {
        email: "We just emailed you a link with more information.",
        phone: "We just texted you a link with more information."
      },
      confirm: {
        email: "Back to Main Menu",
        phone: "Back to Main Menu"
      }
    },
    home: {
      title: "How Important Is",
      emphasizedTitle: "Air Quality?",
      description:
        "Here at [SHORT NAME] and everywhere else in Maricopa County, we all have one thing in common: the air we breathe. The average adult inhales nearly two gallons of air every minute, and kids breathe even more!",
      callToAction:
        "Touch a topic below to learn more about our air and how you can help keep it clean.",
      options: {
        current: "Current Air Quality At",
        woodburning: "Wood burning",
        woodburning2: "Pollution",
        body: "Air Pollution",
        body2: "and the Body",
        commit: "Commit to",
        commit2: "One Day",
        more: "Tell Me",
        more2: "More",
        survey: "Take Our",
        survey2: "Survey"
      },
      begin: {
        initial: "Touch to Begin",
        dothis: "Let's Do This",
        thatsme: "Hey That's Me!",
        resist: "I Can't Resist"
      },
      loop: {
        title: {
          dothis: "Every Time This Screen is Touched",
          thatsme: "Only touch this screen",
          resist: "You’ve been chosen to"
        },
        subtitle: {
          dothis: "our air gets cleaner.",
          thatsme: "if you breathe.",
          resist: "touch this screen."
        }
      }
    },
    navigation: {
      home: "Home",
      current: "Current Air\nQuality",
      woodburning: "Wood Burning\nPollution",
      body: "Air Pollution\nand the Body",
      commit: "Daily\nActions",
      more: "Tell Me\nMore",
      survey: "Take The\nSurvey"
    },
    survey: {
      title: "Take The Survey",
      close: "Close",
      url: "https://survey.sogosurvey.com/r/dmm2i2"
    },
    glossary: {
      pm2_5: {
        title: "PM2.5:",
        subtitle: "Fine Particle Pollution",
        description:
          "PM2.5 is fine particulate matter less than 2.5 micrometers in diameter that results from fuel combustion from motor vehicles, power generation, and industrial facilities, as well as smoke from residential fireplaces and wood stoves.",
        current: "Current PM2.5",
        status: {
          low: "Enjoy your outdoor activities.",
          medium:
            "If medium readings continue (for an hour or more), use the Air Quality Index to plan outdoor activities.",
          high:
            "You may be near a source of particle pollution like dust, smoke or exhaust.  Check the Air Quality Index to plan outdoor activities.",
          veryhigh:
            "You may be near a source of particle pollution like dust, smoke or exhaust.  Check the Air Quality Index to find out if you should adjust outdoor activities.  Very high readings may mean the sensor is not working properly.",
          nodata:
            "There is currently no data available from our sensors. Check the air quality index for Maricopa county."
        }
      },
      pm10: {
        title: "PM10:",
        subtitle: "Coarse Particle Pollution",
        description:
          "PM10 is coarse particulate matter greater than 2.5 micrometers in diameter and less than 10 micrometers in diameter that results from crushing or grinding operations and dust stirred up by vehicles on roads.",
        current: "Current PM10",
        status: {
          low: "Enjoy your outdoor activities.",
          medium:
            "If medium readings continue (for an hour or more), use the Air Quality Index to plan outdoor activities.",
          high:
            "You may be near a source of particle pollution like dust, smoke or exhaust.  Check the Air Quality Index to plan outdoor activities.",
          veryhigh:
            "You may be near a source of particle pollution like dust, smoke or exhaust.  Check the Air Quality Index to find out if you should adjust outdoor activities.  Very high readings may mean the sensor is not working properly.",
          nodata:
            "There is currently no data available from our sensors. Check the air quality index for Maricopa county."
        }
      },
      o3: {
        title: "Ozone:",
        subtitle: "Ground Level Gas Pollution",
        description:
          "Ground-level ozone forms when emissions from vehicles, gasoline and diesel equipment, industrial and chemical processes and other everyday activities react to sunlight.",
        current: "Current Ozone",
        status: {
          low: "Enjoy your outdoor activities.",
          medium:
            "If medium readings continue (for an hour or more), use the Air Quality Index to plan outdoor activities.",
          high:
            "If high readings continue, consider adjusting outdoor activities, especially if you are sensitive to ozone. Check the Air Quality Index to find out.",
          veryhigh:
            "If high readings continue, consider adjusting outdoor activities. Check the Air Quality Index to find out.  Very high readings may mean the sensor is not working properly.",
          nodata:
            "There is currently no data available from our sensors. Check the air quality index for Maricopa county."
        }
      }
    },
    forecast: {
      title: "Air Quality Matters.",
      intro:
        "The quality of our air affects how you live and breathe.  Like the weather, it can change from day to day, hour to hour, and location to location.",
      intro2:
        "Explore the air quality right here at [SHORT NAME] captured every 15 minutes using new, real-time monitoring technologies and see how it compares to other locations across the Valley.",
      cta: "Tap the elements to learn more.",
      forecastTitle: "Current Air Quality at",
      forecastSubtitle: "The chart below shows readings from the past hour.",
      countyTitle: "Air Quality in Maricopa County",
      description: {
        tbd:
          "No forecast data is available at this time. Please check back soon.",
        good: "No restrictions at this time",
        moderate: "Sensitive people should be careful when outdoors",
        sensitive: "Sensitive people should limit outdoor activity",
        unhealthy: "Everybody should limit all outdoor activities",
        very_unhealthy: "Everybody should limit all outdoor activities",
        dangerous: "Everybody should limit all outdoor activities"
      },
      status: {
        none: "No restrictions in effect",
        hpa: "High Pollution Advisory",
        hw: "Health Watch"
      },
      restrictions: {
        atv: {
          allowed: "Off-Highway Vehicles OK",
          restricted: "No Off-Highway Vehicles"
        },
        leafblower: {
          allowed: "Leafblowers OK",
          restricted: "No Leafblowers"
        },
        woodburning: {
          allowed: "Wood burning OK",
          restricted: "No Wood burning"
        }
      },
      buttons: {
        history: "View History",
        compare: "Compare Locations"
      },
      metric: {
        pm2_5: { description: "Fine Particles", name: "PM 2.5" },
        o3: { description: "Ground Level Gas", name: "Ozone" },
        pm10: { description: "Coarse Particles", name: "PM 10" }
      },
      level: {
        high: "High",
        low: "Low",
        medium: "Moderate",
        veryhigh: "Very High",
        nodata: "No Data"
      },
      conjunction: "and",
      direction: {
        increasing: "Increasing",
        stable: "Stable",
        decreasing: "Decreasing"
      }
    },
    history: {
      title: "Air Quality History",
      subtitle:
        "See how pollutant readings at [SHORT NAME] have changed over the last week.",
      close: "Close",
      veryhigh: "Very High",
      high: "High",
      medium: "Medium",
      low: "Low"
    },
    compare: {
      title: "Compare Locations",
      subtitle: "See how air pollution readings compare across the Valley."
    },
    woodburning: {
      title: "Can one log really hurt anyone?",
      intro:
        "New Year’s Day, 2016.  As Phoenix slowly awakens on this brisk, 36-degree Friday morning, many throw a log or two on the fire to get the holiday weekend started.",
      secondary:
        "Drag the slider to see what happens to the Phoenix skyline during prime holiday wood burning season.",
      noburn: {
        title: "No Burn Day?",
        subtitle: "Don’t Burn Wood!",
        description1:
          "Both short- and long-term exposure to particle pollution from wood smoke has been linked to a variety of health effects, including lung disease, asthma attacks, acute bronchitis, and respiratory infections.",
        description2:
          "Help keep our air clean and our neighbors healthy. Burn Cleaner, Burn Better and don’t burn wood or wax logs on a No Burn Day."
      }
    },
    body: {
      title: "Air Quality and the Body",
      intro:
        "Like smoking or poor dietary habits, polluted air poses a threat to our bodies in many ways. Air pollution is at its worst in large metropolitan areas like Phoenix, and causes a range of respiratory, cardiovascular, and neurological symptoms.",
      cta: "Tap the elements to learn more.",
      nav: {
        neurological: {
          title: "Neurological Effects",
          description:
            "Not thinking straight?  See what air pollution does to the brain."
        },
        respiratory: {
          title: "Respiratory Effects",
          description:
            "How does air pollution effect your lungs?  Hint: It’s worse than tobacco!"
        },
        cardio: {
          title: "Cardiovascular Effects",
          description:
            "Thump, thump, clunk!  Air pollution effects your heart in many ways."
        }
      },
      hotspots: {
        neuro: {
          one: {
            headline: "Particulate Matter and Strokes",
            description:
              "Particulate matter, especially fine particulates (PM2.5), increase the risk of strokes and of death from strokes, especially for women. Data from the Women’s Health Initiative show that for each increase of 10μg/m3* in the PM2.5 concentration, women faced a 35% increase in the risk of a cerebrovascular event and an 83% increase in the risk of death from a cerebrovascular event."
          },
          two: {
            headline: "Particulate Matter and Alzheimer’s",
            description:
              "Long-term exposure to high Particulate Matter concentrations can decrease total brain volume and increase infarcts—also known as “silent strokes.” One study showed at 9 months of exposure to elevated Particulate Matter, an Alzheimer's disease-like inflammation profile was observed in the brain."
          },
          three: {
            headline: "Feeling Tired?",
            description:
              "High concentrations of ground-level ozone, the main ingredient in urban and regional smog, can cause headaches, nausea, malaise, fatigue, and a lowered resistance to infection."
          }
        },
        cardio: {
          one: {
            headline: "Tiny Particles, Big Problems",
            description:
              "Particulate Matter exposure can result in significant changes in many cardiovascular indexes such as heart rate, heart rate variability, blood pressure, and blood coagulability. Particulate Matter pollution has also been linked with vascular inflammation, including increased risk of blood clot formation and the narrowing of the heart’s blood vessels."
          },
          two: {
            headline: "Recognize the Symptoms",
            description:
              "Chest tightness, angina (chest pain,), palpitations, shortness of breath, and unusual fatigue are all symptoms of air pollution’s effects on our fragile cardiovascular system, and can lead to increased sickness or premature death from coronary artery disease, abnormal heart rhythms, and congestive heart failure."
          },
          three: {
            headline: "Cardiovascular Risks for Women",
            description:
              "According to a 2007 study published in the New England Journal of Medicine, Particulate Matter pollution poses a serious threat to women, producing a 76% GREATER risk of cardiovascular disease and death."
          }
        },
        respiratory: {
          one: {
            headline: "Is Something Burning?",
            description:
              "You can thank ground-level ozone pollution—which is at its peak in Arizona’s summer months—for your burning eyes, throat, and irritated mucous membranes."
          },
          two: {
            headline: "Trouble Breathing?",
            description:
              "Shortness of breath, wheezing, and coughing are common symptoms of air pollution. Children are amongst the most vulnerable because their respiratory systems are still developing. They're more active and spend more time outdoors, inhaling more air pollution per pound of body weight than do adults."
          },
          three: {
            headline: "Take a Deep Breath...",
            description:
              "Air pollution, especially fine particles (PM 2.5,) age your lungs prematurely by narrowing your airways and decreasing air flow. This can lead to a greater risk of respiratory infection and is related to increased sickness and premature death from asthma, bronchitis, emphysema, and pneumonia."
          }
        }
      }
    },
    commit: {
      title: "Help Keep Ozone Away Commit to One Day!",
      intro:
        "By making easy changes to daily activities at least one day a week—reducing driving, riding public transportation, refueling after dark or riding a bike to work—Maricopa County residents can have a great impact on reducing ozone concentrations and helping keep our air clean.",
      cta: "Tap the icons below to learn more.",
      bike: {
        title: "Bike",
        intro:
          "Ride your bicycle to places you would normally drive your car. Get some fresh air and save some gas while reducing air pollution."
      },
      ride: {
        title: "Ride",
        intro:
          "Utilize alternate modes of transportation. Consider taking the light rail, bus or vanpool."
      },
      walk: {
        title: "Walk",
        intro:
          "Reducing air pollution can be as easy as walking to nearby locations instead of driving. Increase the number of steps on your pedometer and improve your health."
      },
      fuel: {
        title: "Fuel",
        intro:
          "Hot temperatures and gasoline fumes create ground-level ozone. Reduce the effect and refuel your vehicle at night time."
      },
      sweep: {
        title: "Sweep",
        intro:
          "Sweep your driveway, patio, deck, etc. instead of using a leaf blower. Get some exercise and breathe in fresh air while you burn a few calories."
      },
      idling: {
        title: "Idling",
        intro:
          "Avoid the drive-thru and go inside to order your food, coffee or prescriptions. You won’t have to wait in a long drive-thru line and you will reduce exhaust emissions."
      },
      carpool: {
        title: "Carpool",
        intro:
          "Carpool to as many locations as possible. Riding together decreases the amount of dust and exhaust in the air."
      }
    },
    more: {
      title: "Can we Count on You?",
      intro:
        "Keeping our air clean is a group effort, and we’d love to tell you more about how you can get involved.  Enter your info and we’ll send a one-time link to more information that’s only available to users of this kiosk.  Don’t worry, we won’t add your name to any marketing lists unless you specifically request it.",
      email: {
        placeholder: "Your Email Address",
        button: "Send Email",
        errors: {
          required: "Can not be blank.",
          invalid: "Must be a valid email"
        }
      },
      phone: {
        placeholder: "Your Phone Number",
        disclaimer: "*messaging rates may apply",
        button: "Send Text",
        errors: {
          required: "Can not be blank.",
          invalid: "Must be a valid US phone number"
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/Intl/messages/en-US.js